
export const timelineWidth = 880;
